<template>
    <div v-if="booking">
        <div class="form-row">
            <div class="col-md-10">
                <div class="card flight-card" v-for="(segment,sId) of getFlights">
                    <input type="checkbox" class="form-check-input" v-model="selected[sId]"
                        @change="setSelected()" :disabled="move || dateChange">
                    <a data-toggle="collapse" :data-target="'#segment' + sId" aria-expanded="false" :aria-controls="'#segment' + sId">
                        <div class="card-header card-row">
                            {{getSegmentData(segment)}}
                        </div>
                    </a>
                    <div class="collapse" :id="'segment' + sId" >
                        <div class="card-body pax-segments">
                            <ul class="list-group list-group-flush" >
                                <li class="list-group-item row" v-for="passenger in booking.Passengers">
                                    <a data-toggle="collapse" :data-target="'#segment' + sId + passenger.PassengerID"
                                        aria-expanded="false" :aria-controls="'#segment' + sId + passenger.PassengerID">
                                        <div class="col-12">
                                            <p>{{passenger.LastName}}, {{passenger.FirstName}} {{passenger.PaxType}} {{getLiftStatus(passenger, sId)}}</p>
                                        </div>
                                    </a>
                                    <div class="collapse" :id="'segment' + sId + passenger.PassengerID" >
                                        <div class="col-12">
                                            <p class="mb-1">SSRs:</p>
                                            <div v-if="getSsrList(passenger, segment).length" class="ssr-list">
                                                <span v-for="ssr in getSsrList(passenger, segment)" :key="ssr.key" class="ssr-chip">
                                                    {{ssr.code}}
                                                    <button type="button" class="ssr-chip-remove" title="Eliminar SSR"
                                                            @click="removeSsr(passenger, segment, ssr)">×</button>
                                                </span>
                                            </div>
                                            <p v-else class="mb-0 text-muted">—</p>
                                        </div>
                                        <div class="col-12">
                                            <p>Bags: {{getBaggageTags(passenger, segment)}}</p>
                                        </div>
                                        <div class="col-12" v-if="segment.Legs[0]">
                                            <p>Asiento: {{getUnitDesinator(passenger, segment)}}</p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-2">
                <div class="form-row">
                    <button type="button" class="btn btn-primary button-row"
                    :disabled="!isSelected"
                    @click="deleteSegments(false)">Eliminar</button>
                </div>
                <div class="form-row">
                    <button type="button" class="btn btn-primary button-row"
                    :disabled="!canRefundSegmentSelected"
                    @click="refundSelectedSegment">Devolver</button>
                </div>
                <div class="form-row">
                    <button type="button" class="btn btn-primary button-row" @click="addSegments(false)">Agregar</button>
                </div>
                <div class="form-row">
                    <button type="button" class="btn btn-primary button-row" @click="addSegments('move')"
                    :disabled="countSelected!=1 || !userCanMove">Mover</button>
                </div>
                <div class="form-row">
                    <button type="button" class="btn btn-primary button-row" @click="addSegments('dateChange')"
                    :disabled="countSelected!=1 || !hasSegmentID">Cambio de Fecha</button>
                </div>
                <div class="form-row">
                    <button type="button" class="btn btn-primary button-row" @click="showOverrideFare"
                    :disabled="countSelected!=1 || !userCanOverrideFare || !hasSegmentID">Override</button>
                </div>

            </div>
        </div>
        <div class="spacer"></div>
        <div class="spacer"></div>
        <flightselect v-if="search" :move="move" :dateChange="dateChange" :flightkey="getSelectedFlightKey"
            @close="closeSearch" @deletemoved="deleteMoved"></flightselect>
        <inputvalue v-if="showinputvalue" @save="overrideFare" @close="showinputvalue = false" text="Ingresar Monto"
            :default="defValue" addclass="amount-right"></inputvalue>

    </div>
</template>

<script>
import { mapState } from 'vuex';
var moment = require('moment');
import flightselect from '@/components/booking/FlightSelect';
import inputvalue from '@/components/tools/InputValue';
export default {
  name: 'bookingflights',
  components: {
    flightselect,
    inputvalue
  },
  data  () {
    return {
        selected: {},
        search: false,
        showinputvalue: false,
        move: false,
        dateChange: false,
        LiftStatusValues: {
            0: '',
            1: '(CHECKIN)',
            2: '(EMBARCADO)',
            3: '(NO SHOW)',
            4: '(ENDOSADO)'
        },
        userCanMove: false,
        userCanOverrideFare: false,
        defValue: null,
        fareRules: null,

    }
  },
  mounted () {
    this.setSelectedNull();
    this.userCanMove = app.canAccess(this.user, 'api','POST', '/booking/move_flight/', false);
    this.userCanOverrideFare = app.canAccess(this.user, 'api','POST', '/booking/override_fare/', false);
    this.userCanMoveLegs = app.canAccess(this.user, 'api','POST', '/booking/move_flight_legs/', false);
    this.loadFareRules();
  },
  computed: {
    ...mapState({
        user: state => state.user,
        booking: state => state.booking,
        stations: state => state.stations,
    }),
    getFlights () {
        if (this.booking.Passengers.length>0) return this.booking.Passengers[0].Segments;
        return []
    },
    isSelected (){
        for (let s in this.selected){
            if (this.selected[s]) return true;
        }
    },
    countSelected (){
        let c = 0;
        for (let s in this.selected){
            if (this.selected[s]) c ++;
        }
        return c;
    },
    getSelectedFlightKey () {
        for (let s in this.selected){
            if (this.selected[s]) return this.booking.Passengers[0].Segments[s].SegmentFlightKey;
        }
    },
    hasSegmentID () {
        for (let s in this.selected){
            if (this.selected[s] && this.booking.Passengers[0].Segments[s].SegmentID)
                return true;
        }
    },
    canRefundSegmentSelected () {
        if (this.countSelected != 1 || !this.hasSegmentID) {
            return false;
        }
        if (!this.booking || !this.booking.BookingID) return false;
        let segment = this.getSelectedSegment();
        // A non refundable fare still returns its taxes, so the fare rule is not
        // checked here: the amounts come from the refund preview.
        return !!segment && !segment.IsCharter;
    },


  },
  methods: {
    setSelectedNull () {
        this.selected = {};
        for (let s in this.getFlights) {
            this.selected[s] = false;
        }
    },
    getSegmentData (segment){
        let res = app.getSegmentData(segment, true);
        if (segment.Legs[0] && segment.Legs[0].InventoryLeg) {
            res += ' ' + segment.Legs[0].InventoryLeg.LegStatus;
        }
        return res;
    },
    setSelected (){
        this.selected = Object.assign({}, this.selected);
    },
    deleteMoved () {
        this.deleteSegments(true);
        this.closeSearch();
    },
    deleteSegments: async function (skipFareRule) {
        // Only skip when explicitly true (e.g. after move). A click event is truthy and must not skip.
        let forfeitByIdx = {};
        if (skipFareRule !== true) {
            for (let s in this.selected) {
                if (!this.selected[s]) continue;
                let segment = this.booking.Passengers[0].Segments[s];
                if (!segment || !segment.SegmentID) continue;
                let allowed = await this.checkSegmentRefundAllowed(segment);
                if (!allowed) return;
                let rule = this.findFareRule(segment);
                // Keep fees visible in UI until Grabar; backend forfeits them on save.
                forfeitByIdx[s] = !!(rule && !rule.RefundAllowed);
            }
        }
        for (let s in this.selected){
            if (this.selected[s]) {
                let forfeit = forfeitByIdx[s] === true;
                delete this.selected[s];
                this.bookingDeleteSegment(s, true, forfeit);
            }
        }
        this.selected = Object.assign({}, this.selected);
        //this.$emit("update:booking", Object.assign({}, this.booking));
    },
    getSelectedSegment () {
        for (let s in this.selected) {
            if (this.selected[s]) return this.booking.Passengers[0].Segments[s];
        }
        return null;
    },
    getSelectedSegmentIndex () {
        for (let s in this.selected) {
            if (this.selected[s]) return s;
        }
        return null;
    },
    formatAmount (currency, amount) {
        return (currency || '') + ' ' + parseFloat(amount || 0).toFixed(2);
    },
    paymentRefundableBalance (payment) {
        if (!payment || payment.AuthorizationStatus != 4) return 0;
        let amount = parseFloat(payment.PaymentAmount);
        if (!(amount > 0)) return 0;
        let remaining = amount;
        for (let p of this.booking.Payments || []) {
            if (p.ParentPaymentID == payment.PaymentID) {
                remaining += parseFloat(p.PaymentAmount || 0);
            }
        }
        return remaining > 0 ? remaining : 0;
    },
    findRefundParentPayment (amount) {
        amount = parseFloat(amount);
        let payments = this.booking.Payments || [];
        for (let i = payments.length - 1; i >= 0; i--) {
            let payment = payments[i];
            if (!payment.PaymentID) continue;
            if (this.paymentRefundableBalance(payment) >= amount) {
                return payment;
            }
        }
        return null;
    },
    addSegmentRefundPayment (amount, currency, taxOnly) {
        amount = parseFloat(amount);
        if (!(amount > 0)) return true;
        let parent = this.findRefundParentPayment(amount);
        if (!parent) {
            alert('No hay un pago aprobado con saldo suficiente para devolver ' +
                this.formatAmount(currency, amount));
            return false;
        }
        let authStatus = 4;
        if (parent.PaymentMethodType == 1) authStatus = 2;
        this.booking.Payments.push({
            CurrencyCode: parent.CurrencyCode || currency,
            PaymentMethodCode: parent.PaymentMethodCode,
            PaymentMethodType: parent.PaymentMethodType,
            ParentPaymentID: parent.PaymentID,
            PaymentAmount: -amount,
            CollectedCurrencyCode: parent.CollectedCurrencyCode || parent.CurrencyCode || currency,
            CollectedPaymentAmount: -amount,
            Status: 3,
            AuthorizationStatus: authStatus,
            PaymentMethod: parent.PaymentMethod,
            Installments: parent.Installments,
            AccountNumber: parent.AccountNumber,
            // Marks this refund for Grabar: cancel fee keeps only the non-refunded part.
            AccountDetail: taxOnly ? 'SEG_TAX_REFUND' : 'SEG_REFUND',
            isNew: true,
        });
        return true;
    },
    refundSelectedSegment: async function () {
        // Same lifecycle as Eliminar: stage in memory, persist only on Grabar.
        if (!this.canRefundSegmentSelected) {
            alert('No se puede devolver este segmento');
            return;
        }
        let sId = this.getSelectedSegmentIndex();
        let segment = this.getSelectedSegment();
        if (!segment || !segment.SegmentID || sId == null) return;
        if (!this.checkSegmentStatus(sId)) return;

        let preview;
        try {
            preview = await app.get('/api/booking/refund_preview', {
                BookingID: this.booking.BookingID,
                SegmentID: segment.SegmentID,
            });
        } catch (e) {
            alert('No se pudo calcular el monto a devolver');
            return;
        }
        if (!preview) return;

        let forfeit = false;
        let taxOnly = false;
        if (preview.Allowed === false) {
            if (!preview.CanCancelWithFee) {
                alert(preview.Message || 'Esta tarifa no permite devoluciones');
                return;
            }
            taxOnly = true;
            forfeit = true;
            let refund = this.formatAmount(preview.Currency, preview.RefundAmount);
            alert(
                (preview.Message || 'La tarifa no permite devoluciones') +
                '. Se devolverán únicamente las tasas reintegrables: ' + refund +
                '. Por la diferencia se agregará el cargo de cancelación' +
                (preview.CancellationFeeName ? ' ' + preview.CancellationFeeName : '') + '.'
            );
        }

        if (!this.addSegmentRefundPayment(
            preview.RefundAmount, preview.Currency, taxOnly
        )) {
            return;
        }

        delete this.selected[sId];
        this.bookingDeleteSegment(sId, true, forfeit);
        this.selected = Object.assign({}, this.selected);
    },
    loadFareRules: async function () {
        try {
            this.fareRules = await app.get('/api/farerule/') || [];
        } catch (e) {
            this.fareRules = [];
        }
    },
    cancellationFeeCode (rule) {
        if (!rule) return null;
        return rule.CancellationFeeCode ||
            (rule.CancellationFee && rule.CancellationFee.FeeCode) || null;
    },
    segmentRefundAllowedLocal (segment) {
        if (!segment || segment.IsCharter || !segment.SegmentID) return true;
        if (!this.fareRules || !this.fareRules.length) return true;
        let rule = this.findFareRule(segment);
        if (!rule || rule.RefundAllowed) return true;
        // Non-refundable can still be deleted: a cancellation fee absorbs the fare.
        return !!this.cancellationFeeCode(rule);
    },
    checkSegmentRefundAllowed: async function (segment) {
        if (!segment || segment.IsCharter) return true;
        const cancelMsg =
            'La tarifa no tiene devolución y se va a agregar un cargo de cancelación';
        if (segment.SegmentID && this.booking.BookingID) {
            try {
                let res = await app.get('/api/booking/check_refund', {
                    BookingID: this.booking.BookingID,
                    SegmentID: segment.SegmentID,
                });
                if (res && res.Allowed === false) {
                    if (res.CanCancelWithFee) {
                        alert(cancelMsg);
                        return true;
                    }
                    alert(res.Message || 'Esta tarifa no permite devoluciones');
                    return false;
                }
                return true;
            } catch (e) {
                // fallback below
            }
        }
        if (!this.segmentRefundAllowedLocal(segment)) {
            alert('Esta tarifa no permite devoluciones');
            return false;
        }
        let rule = this.findFareRule(segment);
        if (rule && !rule.RefundAllowed && this.cancellationFeeCode(rule)) {
            alert(cancelMsg);
            return true;
        }
        return true;
    },
    findFareRule (segment) {
        if (!segment || !this.fareRules || !this.fareRules.length) return null;
        let marketType = app.marketTypeForStations(
            segment.DepartureStation, segment.ArrivalStation, this.stations);
        let productClass = segment.ProductClassCode ||
            (segment.ProductClass && segment.ProductClass.id);
        return _.find(this.fareRules, (r) =>
            !r.Closed &&
            r.ProductClassId == productClass &&
            parseInt(r.MarketType, 10) === parseInt(marketType, 10)
        ) || null;
    },
    checkSegmentDateChangeAllowed: async function (segment) {
        if (!segment || segment.IsCharter) return true;
        if (segment.SegmentID && this.booking.BookingID) {
            try {
                let res = await app.get('/api/booking/check_date_change', {
                    BookingID: this.booking.BookingID,
                    SegmentID: segment.SegmentID,
                });
                if (res && res.Allowed === false) {
                    alert(res.Message || 'Esta tarifa no permite cambio de fecha/vuelo');
                    return false;
                }
                return true;
            } catch (e) {
                // fallback below
            }
        }
        try {
            let rules = this.fareRules || await app.get('/api/farerule/');
            let marketType = app.marketTypeForStations(
                segment.DepartureStation, segment.ArrivalStation, this.stations);
            let productClass = segment.ProductClassCode ||
                (segment.ProductClass && segment.ProductClass.id);
            let rule = _.find(rules || [], (r) =>
                !r.Closed &&
                r.ProductClassId == productClass &&
                parseInt(r.MarketType, 10) === parseInt(marketType, 10)
            );
            if (rule && !rule.DateChangeAllowed) {
                alert('La tarifa (' + (rule.Name || productClass) +
                    ') no permite cambio de fecha/vuelo');
                return false;
            }
        } catch (e) {
            alert('No se pudo validar la regla tarifaria');
            return false;
        }
        return true;
    },
    checkSegmentStatus (sId) {
        let segment = this.booking.Passengers[0].Segments[sId];
        let legIDs = [];
        for (let leg of segment.Legs) {
            legIDs.push(leg.InventoryLegID);
        }
        if (legIDs.length>0) {
            for (let pax of this.booking.Passengers) {
                for (let s of pax.Segments) {
                    for (let leg of s.Legs) {
                        if (legIDs.indexOf(leg.InventoryLegID)==-1) continue;
                        if (leg.LiftStatus==1 && !this.userCanMoveLegs) {
                            alert('No se puede eliminar o mover el segmento. Pasajeros chequeados')
                            return false;
                        }
                        if (leg.LiftStatus==2 && !this.userCanMoveLegs) {
                            alert('No se puede eliminar o mover el segmento. Pasajeros embarcados')
                            return false;
                        }
                        if (leg.LiftStatus==4 && !this.userCanMoveLegs) {
                            alert('No se puede eliminar o mover el segmento. Pasajeros endosado')
                            return false;
                        }
                    }
                }
            }
        }
        return true;
    },
    bookingDeleteSegment (sId, moveFees, forfeitFees) {
        if (moveFees === undefined) moveFees = true;
        if (forfeitFees === undefined) forfeitFees = false;
        //let segment = _.find(this.booking.Passengers[0].Segments, (s) => s.SegmentFlightKey==SegmentFlightKey);
        if (!this.checkSegmentStatus(sId)) return;
        let segment = this.booking.Passengers[0].Segments[sId];
        let legIDs = [];
        for (let leg of segment.Legs) {
            legIDs.push(leg.InventoryLegID);
        }
        if (legIDs.length>0) {
            for (let p of this.booking.Passengers) {
                let i = _.findIndex(p.Segments, function(s) {
                    for (let leg of s.Legs) {
                        if (leg.InventoryLegID==legIDs[0]) return true;
                    }
                });
                if (i>-1) {
                    if (moveFees) this.moveFeesToPasenger(p, p.Segments[i], forfeitFees);
                    p.Segments.splice(i, 1);
                }
            }
        } else {
            for (let p of this.booking.Passengers) {
                let i = _.findIndex(p.Segments, function(s) {
                    return segment.SegmentFlightKey==s.SegmentFlightKey;
                });
                if (i>-1) {
                    if (moveFees) this.moveFeesToPasenger(p, p.Segments[i], forfeitFees);
                    p.Segments.splice(i, 1);
                }
            }

        }
        app.bookingSumUp(this.booking);
    },
    moveFeesToPasenger (p, s, forfeitFees) {
        for (let fee of s.Fees) {
            let info = "";
            if (s.Legs.length>0 && s.Legs[0].InventoryLeg) {
                info = s.Legs[0].InventoryLeg.FlightNumber;
            }
            info = info + ' ' + s.DepartureStation + '-' + s.ArrivalStation;
            if (s.DepartureDate) {
                info = info + ' ' + moment(s.DepartureDate).locale('es').format('DD MMM YY');
            }
            let newFee = {
                CreatedUserID: fee.CreatedUserID,
                CreatedUTC: fee.CreatedUTC,
                FeeCode: fee.FeeCode,
                FeeDetail: fee.FeeDetail,
                Note: fee.Note,
                FeeType: fee.FeeType,
                FeeOverride: fee.FeeOverride,
                Status: fee.Status,
                SSRCode: fee.SSRCode,
                SSRNumber: fee.SSRNumber,
                UnitValue: fee.UnitValue,
                PaymentID: fee.PaymentID,
                FeeNumber: app.getNextFeeNumber(p.Fees),
                Charges: fee.Charges,
                ArrivalStation: s.ArrivalStation,
                DepartureStation: s.DepartureStation,
                isNew: true,
                // UI-only until Grabar: stripped before POST; backend deletes segment fees.
                ForfeitWithSegment: !!forfeitFees,
                ForfeitFlightInfo: info.trim(),
            }
            p.Fees.push(newFee);
        }
    },
    addSegments: async function (mode) {
        // mode: false/'add' | 'move' | 'dateChange'
        if (mode === true) mode = 'move';
        if (mode === 'move' && !this.userCanMove) {
            alert('Sin permiso para esta acción');
            return;
        }
        if (mode === 'move' || mode === 'dateChange') {
            for (let s in this.selected){
                if (this.selected[s]) {
                    if (!this.checkSegmentStatus(s)) return;
                    if (mode === 'dateChange') {
                        let segment = this.booking.Passengers[0].Segments[s];
                        if (segment && segment.SegmentID) {
                            let allowed = await this.checkSegmentDateChangeAllowed(segment);
                            if (!allowed) return;
                        }
                    }
                }
            }
        }
        this.move = (mode === 'move');
        this.dateChange = (mode === 'dateChange');
        this.search = true;
        this.$nextTick(function () {
          //$('#flightselect').modal('show')
        })
    },
    getLiftStatus (pax, sId) {
        //let segment = _.find(this.booking.Passengers[0].Segments, (s) => s.SegmentFlightKey==SegmentFlightKey);
        let segment = this.booking.Passengers[0].Segments[sId];
        let legIDs = [];
        for (let leg of segment.Legs) {
            legIDs.push(leg.InventoryLegID);
        }
        if (legIDs.length>0) {
            for (let s of pax.Segments) {
                for (let leg of s.Legs) {
                    if (legIDs.indexOf(leg.InventoryLegID)==-1) continue;
                    return this.LiftStatusValues[leg.LiftStatus];
                }
            }
        }
    },
    getSSRs (pax, s) {
        return this.getSsrList(pax, s).map((item) => item.code).join(', ');
    },
    getSsrList (pax, s) {
        let res = [];
        let seen = {};
        for (let segment of pax.Segments) {
            if (segment.SegmentFlightKey != s.SegmentFlightKey) continue;
            for (let leg of segment.Legs || []) {
                for (let ssr of leg.SSRs || []) {
                    let key = [ssr.SSRCode, ssr.SSRNumber || 1, leg.LegNumber].join('-');
                    if (seen[key]) continue;
                    seen[key] = true;
                    res.push({
                        key: key,
                        code: ssr.SSRCode,
                        ssrNumber: ssr.SSRNumber || 1,
                        legNumber: leg.LegNumber,
                        segmentId: segment.SegmentID,
                    });
                }
            }
        }
        return res;
    },
    removeSsr (pax, flightSegment, ssrInfo) {
        if (!confirm('¿Eliminar SSR ' + ssrInfo.code + '? Luego grabá la reserva para confirmar.')) return;
        let segment = _.find(pax.Segments, (item) => item.SegmentFlightKey == flightSegment.SegmentFlightKey);
        if (!segment) return;
        for (let leg of segment.Legs || []) {
            if (!leg.SSRs || !leg.SSRs.length) continue;
            if (ssrInfo.legNumber && leg.LegNumber != ssrInfo.legNumber) continue;
            leg.SSRs = leg.SSRs.filter((ssr) => {
                if (ssr.SSRCode != ssrInfo.code) return true;
                if ((ssr.SSRNumber || 1) != ssrInfo.ssrNumber) return true;
                return false;
            });
        }
        this.$store.commit('setBooking', Object.assign({}, this.booking));
    },
    getUnitDesinator (pax, s) {
        let res = [];
        for (let segment of pax.Segments){
            if (segment.SegmentFlightKey==s.SegmentFlightKey) {
                if (segment.Legs[0]) return segment.Legs[0].UnitDesignator;
            }
        }
        return '';
    },

    getBaggageTags (pax, s) {
        let res = []
        let segment = _.find(pax.Segments, (r)=> r.SegmentFlightKey==s.SegmentFlightKey);
        if (!segment) return '';
        for (let bag of pax.Baggages) {
            let f = _.find(bag.LegBaggages, function(b) {
                if (segment.Legs.length>0) {
                    return b.SegmentID==segment.SegmentID && b.LegNumber==segment.Legs[0].LegNumber && b.BaggageStatus!=2;
                }
            })
            if (f) {
                res.push(bag.OSTag + ' / ' + bag.Weight + ' Kg')
            }
        }
        return res.join(', ');
    },

    closeSearch () {
        this.search = false;
        this.setSelectedNull();
        this.move = false;
        this.dateChange = false;
        //this.$emit("update:booking", Object.assign({}, this.booking));
        //$('#flightselect').modal('hide');
    },
    showOverrideFare () {
      if (!this.userCanOverrideFare) {
          alert('Sin permiso para esta acción');
          return;
      }
      this.showinputvalue = true;
      let k;
      for (let i in this.selected) {
        if (this.selected[i]) {
            k = i;
        }
      }
      let segment = this.booking.Passengers[0].Segments[k];
      if (!segment) return;
      let fare;
      for (let charge of segment.Charges) {
        if (charge.ChargeCode==null) {
            fare = charge.ChargeAmount;
            break;
        }
      }
      if (fare) this.defValue = fare;
      this.$nextTick(function() {
        $('#inputValue').modal('show');
      })
    },
    overrideFare: async function(value) {
      let k;
      for (let i in this.selected) {
        if (this.selected[i]) {
            k = i;
        }
      }
      let segment = this.booking.Passengers[0].Segments[k];
      if (!segment) return;
      for (let pax of this.booking.Passengers) {
        for (let s of pax.Segments) {
            if (s.SegmentFlightKey==segment.SegmentFlightKey) {
                await this.applyFare(s, parseFloat(value));
            }
        }
      }
      app.bookingSumUp(this.booking);
      $('#inputValue').modal('hide');
      this.showinputvalue = false;
      this.defValue = null;
    },
    applyFare: async function(s, value) {
        let data = {
            DepartureDate: s.DepartureDate,
            DepartureStation: s.DepartureStation
        }
        let tax_settings = await app.get('/api/booking/get_tax_settings', data);
        if (tax_settings) {
            let fees = tax_settings.Fees || {};
            for (let charge of s.Charges) {
                if (charge.ChargeCode==null) {
                    charge.ChargeAmount = value;
                    charge.ForeignAmount = value;
                } else if (fees[charge.ChargeCode]) {
                    charge.ChargeAmount = value * fees[charge.ChargeCode];
                    charge.ForeignAmount = value * fees[charge.ChargeCode];
                }
            }
        }
    }

  }
}
</script>

